export default {
    home: 'Home',
    about: 'About',
    faq: 'FAQ',
    cite: 'Cite',
    eula: 'Terms of Use',
    documentation: 'Documentation',
    contactus: 'Contact Us',
    login: 'Log in',
    logout: 'Logout',

    forename: 'Forename',
    surname: 'Surname',
    email: 'Email',
    password: 'Password',
    repassword: 'Repeat Password',
    organization: 'Organization',
    enterYourPassword: 'Enter your Password',

    registration: 'Registration',
    register: 'Register',
    start: 'Start Working',

    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    change: 'Change',
    updateUserDetails: 'Update User Details',
    update: 'Update',

    forgotPassword: 'Forgot Password',
    changeForgottenPassword: 'Change Forgotten Password',

    activateUser: 'Activate User',
    activate: 'Activate',

    confirmInvitation: 'Confirm Invitation',
    accept: 'Accept'
};
